const RiskIndicator = require('./RiskIndicator');

module.exports = RiskIndicator;